/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Playbar_ModeInputs */

const en_highlight_settings_playbar_mode = /** @type {(inputs: Highlight_Settings_Playbar_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playbar Mode`)
};

const es_highlight_settings_playbar_mode = /** @type {(inputs: Highlight_Settings_Playbar_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de reproducción`)
};

/**
* | output |
* | --- |
* | "Playbar Mode" |
*
* @param {Highlight_Settings_Playbar_ModeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_playbar_mode = /** @type {((inputs?: Highlight_Settings_Playbar_ModeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Playbar_ModeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_playbar_mode(inputs)
	return en_highlight_settings_playbar_mode(inputs)
});